import axios from "axios";
import Encrypt from "../utils/encode";

// const Integrated_API_URL = "http://localhost:5233/";
const Integrated_API_URL = "/";
// const baseURL="http://localhost:5233/";
const baseURL="/";

// export const sendOtp = async (data) => {
//     try {
//         const response = await axios.post(`${baseURL}auth/sendOtp`, data);
//         return response.data.message;
//     } catch (e) {
//         throw e.response.data;
//     }
// };


export const addLuckyWheel = async (msisdn, lastSpin, reword) => {
    const response = await axios.post(`${baseURL}api/lucky-wheel/add`, {
        msisdn,
        lastSpin,
        reword
    });

    return response.data;
};

export const getLuckyWheel = async (msisdn) => {
    const response = await axios.get(`${baseURL}api/lucky-wheel`, {
        params: {
            msisdn
        }
    });

    return response.data;
};



export const sendOtpzip=async(msisdn)=>{
 const response = await axios.post(`${baseURL}api/v1/zip-game/sendOtp`, {
        msisdn
    })
    return response.data;
}
export const varifyOtpzip=async(msisdn,otp)=>{
 const response = await axios.post(`${baseURL}api/v1/zip-game/verifyOtp`, {
        msisdn,otp
    })
    return response.data;
}

export const login = async (data) => {
    const response = await axios.post(`${baseURL}api/v1/login`, data);
    return response;
};

export const getFunFact = async () => {
    const response = await axios.get(`${baseURL}api/v1/fun-facts`);
    return response;
};

export const getProfile = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-user-profile`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getAllQuiz = async (language, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-all-quizes?lang_id=${language}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getQuiz = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response;
}

export const getQuizDetails = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response?.data?.result?.data;
}

export const getLeaderboard = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-leaderboard`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};
export const getmegaQuizeLeaderboard = async () => {
    const response = await axios.get(`${baseURL}api/v1/magaquize/leaderboard`);
    return response;
};

export const updateProfile = async (formData, token) => {
    try {
        const response = await axios.post(`${baseURL}api/v1/protected/edit-profile`, formData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data.data;
    } catch (e) {
        console.log(e);
    }
};

export const getHistory = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-history?offset=0`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const getAllOpponent = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/finding-opponent`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const saveUserPoints = async (quizId, quizName, quizImage, levelId, points, totalPoints, token) => {

    const encryptPayload = Encrypt({
        quizId: quizId,
        quizName: quizName,
        quizImage: quizImage,
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-user-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
    return response;
};

export const getReverseQuizQuestions = async (level, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-reverse-quiz-questions?level=${level}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const saveReverseQuizPoints = async (levelId, points, totalPoints, token) => {

    const encryptPayload = Encrypt({
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-reverse-quiz-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });

    return response;
}

export const checkUserSubscription = async (token) => {
    console.log(token)
    const response = await axios.get(`${baseURL}api/v1/protected/check-user-subscription`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const saveWordGamePointsApi = async (levelId, points, totalPoints, token) => {
    const encryptPayload = Encrypt({
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-word-game-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });

    return response;
}


// const Integrated_API_URL = "https://apimrw.quizmasterr.com/";
export const sendOtp=async(msisdn,ext_ref)=>{
 const response = await axios.post(`${Integrated_API_URL}OTP/sendOtp`, {
        msisdn,
       
        ext_ref
    })
    return response.data;
}
export const varifyOtp=async(msisdn,otp,pack,ext_ref)=>{
 const response = await axios.post(`${Integrated_API_URL}OTP/verifyOtp`, {
        msisdn,otp,
        pack_type: pack,
        ext_ref
    })
    return response.data;
}

export const subscribeApi = async (msisdn, pack, extRef) => {
    const response = await axios.post(`${Integrated_API_URL}activate-user`, {
        msisdn,
        pack_type: pack,
        ext_ref: extRef
    });

    return response;
}

export const unsubscribeAPI = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}deactivate-user`, { msisdn });
    return response;
}

// Zip Game Apis

export const registerZipUser = async (msisdn, name) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/register`, {
        msisdn, name
    });
    return response;
}

export const loginZipUser = async (msisdn) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/login`, {
        msisdn
    });
    return response;
}

export const zipPlayGame = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/play`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipSaveScore = async (token, total_time_seconds, moves, game_trx_id) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/save-score`, { total_time_seconds, moves, game_trx_id },
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    return response;
}

export const zipGameResult = async (game_trx_id, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/user-game-result?game_trx_id=${game_trx_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipGameLeaderboardApi = async (date, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/leaderboard?date=${date}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipGameWinnersApi = async (date, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/winners?date=${date}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const checkZipUserSubscription = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/auth/checker`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserProfileApi = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/profile`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserProfileEditApi = async (formData, token) => {
    const response = await axios.post(`${baseURL}api/v1/zip-game/edit-profile`, formData, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const zipUserHistoryApi = async (page, token) => {
    const response = await axios.get(`${baseURL}api/v1/zip-game/history?page=${page}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const sendOtp1 = async (msisdn,token) => {
  try {
    const response = await axios.post(`${baseURL}api/v1/magaquize/sendOtp`, {
      msisdn,
    },{
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Something went wrong",
      }
    );
  }
};

/**
 * Verify OTP
 */
export const verifyOtp1 = async (msisdn, otp ,token) => {
  try {
    const response = await axios.post(`${baseURL}api/v1/magaquize/verifyotp`, {
      msisdn,
      otp,
    },{
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Something went wrong",
      }
    );
  }
};
export const quiz_date  = async (msisdn, otp ,token) => {
  try {
    const response = await axios.get(`${baseURL}api/v1/magaquize/quiz-date`, {
      msisdn,
      otp,
    },{
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Something went wrong",
      }
    );
  }
};
export const quiz_data  = async (selectedLanguage) => {
  try {
    const response = await axios.get(`${baseURL}api/v1/magaquize/questions?languageId=${selectedLanguage}`);

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Something went wrong",
      }
    );
  }
};
export const check_user  = async (msisdn) => {
  try {

    
    const response = await axios.get(`${baseURL}api/v1/magaquize/check-user?msisdn=${msisdn}`);

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Something went wrong",
      }
    );
  }
};
export async function save_result(
       msisdn,
      magaQuizDate,
      submitted,
      totalPoints
){
//save-result
  try {

    
    const response = await axios.post(`${baseURL}api/v1/magaquize/save-result`,{ msisdn: msisdn.msisdn,
      magaQuizDate,
      submitted,
      totalPoints});

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Something went wrong",
      }
    );
  }

}

